import { GetStaticPropsResult } from 'next';

import Page from 'components/Page';
import Body from 'components/base/Body';
import Box from 'components/base/Box';
import { TextHero } from 'components/blocks/TextHero';
import RenderLegal from 'components/renderers/RenderLegal';

import { getContentfulContent } from 'queries/server/content';
import { lastUpdated } from 'utils/dates/dates';

interface PrivacyPolicyProps {
  privacy: string;
  updatedAt: string;
}

export default function PrivacyPolicy(props: PrivacyPolicyProps) {
  const { privacy, updatedAt } = props;

  return (
    <Page title="Privacy Policy" type="MAXIMAL" footerMode="LIGHT">
      <Body
        css={{
          backgroundColor: '$white100',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <TextHero
          heading="Privacy Policy"
          subheading={`Last updated – ${lastUpdated(updatedAt)}`}
        />
        {privacy && (
          <Box
            as="main"
            css={{
              maxWidth: 820,
              paddingX: '$7',
              marginX: 'auto',
              paddingBottom: '$10',
            }}
          >
            {RenderLegal(privacy)}
          </Box>
        )}
      </Body>
    </Page>
  );
}

export async function getStaticProps(): Promise<
  GetStaticPropsResult<PrivacyPolicyProps>
> {
  const { privacy, updatedAt } = await getContentfulContent();

  return {
    props: {
      privacy: privacy ?? null,
      updatedAt: updatedAt ?? null,
    },
    //  1 hour
    revalidate: 60 * 60,
  };
}
